
import { DevicesActivity } from '../DevicesActivity';
import { VenuesOrg } from '../VenuesOrg';

export class ExchangeReportsPartner extends DevicesActivity {

  constructor(props) {
    super(props, {pageForOrgType: 'PARTNER', exchangeReportsTrimmed: true})
  }
}


// WEBPACK FOOTER //
// ./src/screens/admin/partners/ExchangeReportsPartner.js